// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.awards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  width: 100%;
}

.awards--container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1480px;
  gap: 56px;
  padding: 0 24px;
  width: 100%;
  z-index: 1;
}

div.awards > div > div.comp-title > h2{
  color: #3B3B3B;
}

/* Prize Categories */
.prize-categories {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  background-color: var(--color-primary-green-ethanol);
  border-radius: 24px;
  overflow: hidden;
}

.category {
  flex: 1;
  padding: 20px;
  text-align: center;
  color: var(--text-light);
  font-family: ShellHeavy, var(--default-font-family);
  font-size: 18px;
  font-weight: 600;
}

.highlight {
  color: var(--shell-yellow);
}

.category-fuel {
  border-radius: 24px 0 0 24px;
}

.category-experience {
  border-radius: 0 24px 24px 0;
}

/* Prize Slider Section */
.prize-slider {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 60px auto;
  height: 400px;
  overflow: visible;
  width: 100%;
  flex-direction: column;
  padding: 20px 0;
}

/* Containers para os prêmios */
.prize-slider {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin: 60px auto 0; /* Aumentando a margem inferior para acomodar as setas */
  height: 450px;
  overflow: visible;
  max-width: 100%;
  width: 100%;
  padding: 0 20px;
}

/* Left Container (viewed prizes) */
.slider-left-container {
  width: 457px;
  max-width: 457px;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  overflow: visible;
  left: 0;
}

/* Right Container (upcoming prizes) */
.slider-right-container {
  width: 388px;
  max-width: 388px;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  overflow: visible;
  right: 50px;
}

/* Informações do prêmio */
.prize-info {
  text-align: left;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  position: absolute;
  left: 53%;
  top: 40%;
  transform: translate(-50%, -50%);
  z-index: 10;
  width: 300px;
  color: var(--color-contrast-dark-gray);
  transition: all 800ms cubic-bezier(0.4, 0, 0.2, 1); /* Mesma transição dos itens do slider */
}

/* Animação para as informações do prêmio */
.prize-info.changing {
  opacity: 0;
  transform: translate(-50%, -40%);
}

.prize-info.active {
  opacity: 1;
  transform: translate(-50%, -50%);
  animation: fadeIn 800ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.prize-title {
  margin-bottom: 50px;
}

.prize-type {
  display: inline-block;
  padding: 5px 15px;
  border-radius: 20px;
  font-family: ShellHeavy, var(--default-font-family);
  font-size: 16px;
  color: var(--color-primary-white);
  margin-bottom: 25px;
}

.prize-type.tipo1 {
  background-color: var(--color-primary-green-ethanol);
}

.prize-type.tipo2 {
  background-color: var(--color-primary-red);
}

.description-highlight {
  font-family: ShellHeavy, var(--default-font-family);
  font-weight: 600;
}

/* Prize Items */
.prize-item {
  position: absolute;
  transition: all 0.5s ease-in-out;
  border-radius: 8px;
  overflow: hidden;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); */
  transform: translateX(0);
}

/* Keyframes para animações Smart Animate */
@keyframes slideFromRight {
  0% {
    transform: translateX(100px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideToLeft {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-100px);
    opacity: 0;
  }
}

@keyframes scaleDown {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* Prize items in the left container */
.slider-left-container .prize-item {
  max-width: 320px; /* Reduzindo para 320px conforme solicitado */
  width: 100%;
  transition: all 800ms cubic-bezier(0.4, 0, 0.2, 1); /* Curva Gentle */
}

/* Item atual/ativo no container esquerdo */
.slider-left-container .prize-item.active {
  max-width: 457px; /* Mantendo o tamanho original para o item ativo */
  width: 100%;
  left: 90px;
  animation: slideFromRight 800ms cubic-bezier(0.4, 0, 0.2, 1) forwards; /* Curva Gentle */
}

/* Animação para os itens que saem */
.slider-left-container .prize-item.leaving {
  animation: slideToLeft 800ms cubic-bezier(0.4, 0, 0.2, 1) forwards; /* Curva Gentle */
}

/* Animação para os itens que entram */
.slider-right-container .prize-item.entering {
  animation: fadeIn 800ms cubic-bezier(0.4, 0, 0.2, 1) forwards; /* Curva Gentle */
}

.slider-left-container .prize-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 388px; /* Reduzindo para 388px conforme solicitado */
  transition: max-width 0.5s ease-in-out;
}

/* Imagem atual/ativa no container esquerdo */
.slider-left-container .prize-item.active img {
  max-width: 457px; /* Mantendo o tamanho original para a imagem ativa */
}

/* Prize items in the right container */
.slider-right-container .prize-item {
  max-width: 388px;
  width: 100%;
}

.slider-right-container .prize-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 388px;
}

/* Card CTA no slider-right-container */
.slider-cta-card {
  position: absolute;
  right: 0;
  width: 320px;
  height: 320px;
  z-index: 30; /* Garantir que fique acima dos itens do slider */
  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1);
}

/* Mostrar o card-cta apenas quando estiver no último slide */
.slider-right-container.show-cta .slider-cta-card {
  opacity: 1;
}

/* Ocultar o card-cta em outros slides */
.slider-right-container:not(.show-cta) .slider-cta-card {
  opacity: 0;
  pointer-events: none;
}

.cta-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  position: relative;
  width: 320px;
  height: 320px;
  padding: 30px 36px 30px 36px;
  background: #f9b500;
  border-radius: 20px;
  transform: rotate(2deg); /* Aplicando rotação de 2 graus */
  transition: transform 0.3s ease;
}

.cta-container:hover {
  transform: rotate(
    0deg
  ); /* Volta à posição normal no hover para um efeito interativo */
}

.cta-title {
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  min-width: 0;
  height: 31px;
  color: #3b3b3b;
  font-family: ShellMedium, var(--default-font-family);
  font-size: 24px;
  font-weight: 500;
  line-height: 31px;
  text-align: left;
  white-space: nowrap;
  z-index: 1;
}

.cta-description {
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  min-width: 0;
  font-family: ShellBook, var(--default-font-family);
  font-size: 18px;
  font-weight: 400;
  line-height: 28.8px;
  text-align: left;
  z-index: 2;
}

.cta-text {
  position: relative;
  color: #3b3b3b;
  font-family: ShellBook, var(--default-font-family);
  font-size: 18px;
  font-weight: 400;
  line-height: 28.8px;
  text-align: left;
}

.cta-highlight {
  position: relative;
  color: #3b3b3b;
  font-family: ShellHeavy, var(--default-font-family);
  font-size: 18px;
  font-weight: 600;
  line-height: 28.8px;
  text-align: left;
}

.cta-space {
  position: relative;
  color: #3b3b3b;
  font-family: ShellHeavy, var(--default-font-family);
  font-size: 18px;
  font-weight: 600;
  line-height: 28.8px;
  text-align: left;
}

.cta-highlight-red {
  position: relative;
  color: var(--color-contrast-dark-red);
  font-family: ShellHeavy, var(--default-font-family);
  font-size: 18px;
  font-weight: 600;
  line-height: 28.8px;
  text-align: left;
}

.cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-wrap: nowrap;
  flex-shrink: 0;
  position: relative;
  min-width: 0;
  height: 54.382px;
  padding: 14px 20px 14px 20px;
  background: var(--color-primary-red);
  border: 1.5px solid var(--color-primary-red);
  z-index: 3;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cta-button:hover {
  background: #b51819;
}

.cta-button-text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  flex-shrink: 0;
  position: relative;
  width: 191px;
  padding: 0 8px 0 8px;
  z-index: 4;
  color: #ffffff;
  font-family: ShellMedium, var(--default-font-family);
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  white-space: nowrap;
}

/* Navigation Controls */
.navigation-controls {
  position: absolute;
  bottom: 0;
  left: 46%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  gap: 5px; /* Espaçamento entre os botões */
  z-index: 20;
}

/* Estilo para quando há apenas uma seta visível */
.navigation-controls.single-arrow {
  justify-content: center;
  left: 44%;
}

.navigation-controls.first-slide .nav-button#prev-button,
.navigation-controls.last-slide .nav-button#next-button {
  display: none;
}

.nav-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.nav-button:hover {
  transform: scale(1.05);
}

.nav-button img {
  width: 48px;
  height: 48px;
}

.nav-button {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.arrow {
  width: 20px;
  height: 20px;
  border-top: 3px solid white;
  border-right: 3px solid white;
  transition: transform 0.3s ease;
}

.arrow-right {
  transform: rotate(45deg);
}

.arrow-left {
  transform: rotate(-135deg);
}

/* Prize Images Container (hidden) */
.prize-images {
  display: none;
}

.awards--extra {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  width: 100%;
}
.awards--extra p {
  color: var(--color-primary-white);
  text-align: center;
}
.awards--extra--center,
.awards--extra--left {
  background: var(--color-primary-green-ethanol);
  padding: 27px 40px;
  position: relative;
  width: 280px;
}
.awards--extra--center::before {
  background: var(--color-primary-white);
  content: '';
  height: 70%;
  left: -1px;
  position: absolute;
  top: 50%;
  transform: translate3d(0px, -50%, 0px);
  width: 1px;
}
.awards--extra--left {
  border-radius: 24px 0px 0px 24px;
}
.awards--extra--right {
  border-radius: 0px 24px 24px 0px;
  background: var(--color-primary-red);
  padding: 12px 24px;
  width: 336px;
}

/* Media Queries para Responsividade */
@media (max-width: 1360px) {
  .slider-left-container .prize-item.active {
    left: 10%;
  }
}

@media (max-width: 1280px) {
  .prize-slider {
    max-width: 798px;
    height: 500px;
    margin: 0 auto;
    padding: 40px 0 80px;
    justify-content: center;
    gap: 50px;
  }

  .slider-left-container,
  .slider-right-container {
    max-width: 100%;
    width: 100%;
    height: 50%;
    padding: 10px;
    z-index: -1;
  }

  .slider-left-container {
    max-width: 400px;
  }

  .slider-left-container .prize-item {
    max-width: 100%;
    width: 100%;
  }

  .slider-left-container .prize-item.active {
    left: 0;
  }

  .slider-right-container {
    opacity: 0;
    display: none;
  }

  .prize-info.active {
    left: unset;
    right: 0;
    transform: translateY(-50%);
  }

  .navigation-controls {
    left: 50%;
  }

  .navigation-controls.single-arrow {
    left: 50%;
  }
}

@media (max-width: 768px) {
  .prize-slider {
    height: 522px;
    margin: 0 auto;
    padding: 0;
  }

  .slider-left-container,
  .slider-right-container {
    max-width: 100%;
    width: 100%;
    height: 50%;
    padding: 10px;
    z-index: -1;
  }

  .slider-left-container .prize-item {
    max-width: 100%;
  }

  .slider-left-container .prize-item.active {
    max-width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    left: 0;
  }

  .slider-right-container {
    opacity: 0;
  }

  .prize-item {
    width: 300px;
    height: 300px;
  }

  .prev-button,
  .next-button {
    width: 30px;
    height: 30px;
  }

  .prev-button {
    left: 10px;
  }

  .next-button {
    right: 10px;
  }

  .prize-info {
    padding: 15px;
  }

  .prize-info.active {
    max-width: 100%;
    width: 100%;
    padding: 0 20px;
    text-align: center;
    top: 0;
    left: 0;
    transform: translate(0);
    animation: fadeIn 00ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }
  
  .prize-title {
    font-size: 24px;
    margin-bottom: 11px;
  }

  .prize-type {
    font-size: 14px;
    margin: 0;
  }

  .prize-description {
    font-size: 14px;
    position: absolute;
    bottom: -400px;
    left: 0;
  }

  .prize-categories {
    flex-direction: column;
    gap: 20px;
    padding: 20px 0;
  }

  .highlight {
    font-size: 20px;
  }

  .category-text {
    font-size: 16px;
  }

  .navigation-controls {
    width: 100%;
    top: 50%;
    bottom: unset;
    left: 0;
    transform: translate(0);
  }

  .navigation-controls.single-arrow {
    left: 0;
  }

  .navigation-controls #prev-button,
  .navigation-controls #next-button {
    position: absolute;
  }

  .navigation-controls #prev-button {
    left: 0;
  }

  .navigation-controls #next-button {
    right: 0;
  }

  .awards--extra {
    flex-wrap: wrap;
  }
  .awards--extra > div {
    height: 96px;
  }
  .awards--extra p.p2-paragraph {
    font-size: var(--font-size-p3-paragraph);
  }
  .awards--extra--center,
  .awards--extra--left {
    padding: 18px 40px;
    width: 50%;
  }
  .awards--extra--left {
    border-radius: 24px 0px 0px 0px;
  }
  .awards--extra--center {
    border-radius: 0px 24px 0px 0px;
  }
  .awards--extra--right {
    border-radius: 0px 0px 24px 24px;
    padding: 28px 24px;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/scripts/components/awards/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oDAAoD;EACpD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB,EAAE,wDAAwD;EAC7E,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,OAAO;AACT;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kDAAkD,EAAE,wCAAwC;AAC9F;;AAEA,2CAA2C;AAC3C;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mDAAmD;EACnD,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sCAAsC;AACtC;EACE,gBAAgB,EAAE,6CAA6C;EAC/D,WAAW;EACX,kDAAkD,EAAE,iBAAiB;AACvE;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB,EAAE,kDAAkD;EACpE,WAAW;EACX,UAAU;EACV,qEAAqE,EAAE,iBAAiB;AAC1F;;AAEA,oCAAoC;AACpC;EACE,kEAAkE,EAAE,iBAAiB;AACvF;;AAEA,sCAAsC;AACtC;EACE,6DAA6D,EAAE,iBAAiB;AAClF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB,EAAE,6CAA6C;EAC/D,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB,EAAE,oDAAoD;AACxE;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,WAAW,EAAE,iDAAiD;EAC9D,sDAAsD;AACxD;;AAEA,6DAA6D;AAC7D;EACE,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB,EAAE,iCAAiC;EAC1D,+BAA+B;AACjC;;AAEA;EACE;;GAEC,EAAE,8DAA8D;AACnE;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,oDAAoD;EACpD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,4CAA4C;EAC5C,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,oDAAoD;EACpD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,QAAQ,EAAE,gCAAgC;EAC1C,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oCAAoC;AACpC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;AACA;;EAEE,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,WAAW;EACX,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,sCAAsC;EACtC,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,WAAW;IACX,WAAW;IACX,aAAa;IACb,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,UAAU;EACZ;;EAEA;;IAEE,eAAe;IACf,WAAW;IACX,WAAW;IACX,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,OAAO;EACT;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,uBAAuB;IACvB,4DAA4D;EAC9D;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,aAAa;IACb,OAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,OAAO;EACT;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,wCAAwC;EAC1C;EACA;;IAEE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,+BAA+B;EACjC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;EACb;AACF","sourcesContent":[".awards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: flex-start;\n  width: 100%;\n}\n\n.awards--container {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  max-width: 1480px;\n  gap: 56px;\n  padding: 0 24px;\n  width: 100%;\n  z-index: 1;\n}\n\ndiv.awards > div > div.comp-title > h2{\n  color: #3B3B3B;\n}\n\n/* Prize Categories */\n.prize-categories {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 40px;\n  background-color: var(--color-primary-green-ethanol);\n  border-radius: 24px;\n  overflow: hidden;\n}\n\n.category {\n  flex: 1;\n  padding: 20px;\n  text-align: center;\n  color: var(--text-light);\n  font-family: ShellHeavy, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.highlight {\n  color: var(--shell-yellow);\n}\n\n.category-fuel {\n  border-radius: 24px 0 0 24px;\n}\n\n.category-experience {\n  border-radius: 0 24px 24px 0;\n}\n\n/* Prize Slider Section */\n.prize-slider {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 60px auto;\n  height: 400px;\n  overflow: visible;\n  width: 100%;\n  flex-direction: column;\n  padding: 20px 0;\n}\n\n/* Containers para os prêmios */\n.prize-slider {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  margin: 60px auto 0; /* Aumentando a margem inferior para acomodar as setas */\n  height: 450px;\n  overflow: visible;\n  max-width: 100%;\n  width: 100%;\n  padding: 0 20px;\n}\n\n/* Left Container (viewed prizes) */\n.slider-left-container {\n  width: 457px;\n  max-width: 457px;\n  height: 100%;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  overflow: visible;\n  left: 0;\n}\n\n/* Right Container (upcoming prizes) */\n.slider-right-container {\n  width: 388px;\n  max-width: 388px;\n  height: 100%;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  overflow: visible;\n  right: 50px;\n}\n\n/* Informações do prêmio */\n.prize-info {\n  text-align: left;\n  width: 100%;\n  max-width: 300px;\n  margin: 0 auto;\n  position: absolute;\n  left: 53%;\n  top: 40%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n  width: 300px;\n  color: var(--color-contrast-dark-gray);\n  transition: all 800ms cubic-bezier(0.4, 0, 0.2, 1); /* Mesma transição dos itens do slider */\n}\n\n/* Animação para as informações do prêmio */\n.prize-info.changing {\n  opacity: 0;\n  transform: translate(-50%, -40%);\n}\n\n.prize-info.active {\n  opacity: 1;\n  transform: translate(-50%, -50%);\n  animation: fadeIn 800ms cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n.prize-title {\n  margin-bottom: 50px;\n}\n\n.prize-type {\n  display: inline-block;\n  padding: 5px 15px;\n  border-radius: 20px;\n  font-family: ShellHeavy, var(--default-font-family);\n  font-size: 16px;\n  color: var(--color-primary-white);\n  margin-bottom: 25px;\n}\n\n.prize-type.tipo1 {\n  background-color: var(--color-primary-green-ethanol);\n}\n\n.prize-type.tipo2 {\n  background-color: var(--color-primary-red);\n}\n\n.description-highlight {\n  font-family: ShellHeavy, var(--default-font-family);\n  font-weight: 600;\n}\n\n/* Prize Items */\n.prize-item {\n  position: absolute;\n  transition: all 0.5s ease-in-out;\n  border-radius: 8px;\n  overflow: hidden;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); */\n  transform: translateX(0);\n}\n\n/* Keyframes para animações Smart Animate */\n@keyframes slideFromRight {\n  0% {\n    transform: translateX(100px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideToLeft {\n  0% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(-100px);\n    opacity: 0;\n  }\n}\n\n@keyframes scaleDown {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.8);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n/* Prize items in the left container */\n.slider-left-container .prize-item {\n  max-width: 320px; /* Reduzindo para 320px conforme solicitado */\n  width: 100%;\n  transition: all 800ms cubic-bezier(0.4, 0, 0.2, 1); /* Curva Gentle */\n}\n\n/* Item atual/ativo no container esquerdo */\n.slider-left-container .prize-item.active {\n  max-width: 457px; /* Mantendo o tamanho original para o item ativo */\n  width: 100%;\n  left: 90px;\n  animation: slideFromRight 800ms cubic-bezier(0.4, 0, 0.2, 1) forwards; /* Curva Gentle */\n}\n\n/* Animação para os itens que saem */\n.slider-left-container .prize-item.leaving {\n  animation: slideToLeft 800ms cubic-bezier(0.4, 0, 0.2, 1) forwards; /* Curva Gentle */\n}\n\n/* Animação para os itens que entram */\n.slider-right-container .prize-item.entering {\n  animation: fadeIn 800ms cubic-bezier(0.4, 0, 0.2, 1) forwards; /* Curva Gentle */\n}\n\n.slider-left-container .prize-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  max-width: 388px; /* Reduzindo para 388px conforme solicitado */\n  transition: max-width 0.5s ease-in-out;\n}\n\n/* Imagem atual/ativa no container esquerdo */\n.slider-left-container .prize-item.active img {\n  max-width: 457px; /* Mantendo o tamanho original para a imagem ativa */\n}\n\n/* Prize items in the right container */\n.slider-right-container .prize-item {\n  max-width: 388px;\n  width: 100%;\n}\n\n.slider-right-container .prize-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  max-width: 388px;\n}\n\n/* Card CTA no slider-right-container */\n.slider-cta-card {\n  position: absolute;\n  right: 0;\n  width: 320px;\n  height: 320px;\n  z-index: 30; /* Garantir que fique acima dos itens do slider */\n  transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Mostrar o card-cta apenas quando estiver no último slide */\n.slider-right-container.show-cta .slider-cta-card {\n  opacity: 1;\n}\n\n/* Ocultar o card-cta em outros slides */\n.slider-right-container:not(.show-cta) .slider-cta-card {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.cta-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  position: relative;\n  width: 320px;\n  height: 320px;\n  padding: 30px 36px 30px 36px;\n  background: #f9b500;\n  border-radius: 20px;\n  transform: rotate(2deg); /* Aplicando rotação de 2 graus */\n  transition: transform 0.3s ease;\n}\n\n.cta-container:hover {\n  transform: rotate(\n    0deg\n  ); /* Volta à posição normal no hover para um efeito interativo */\n}\n\n.cta-title {\n  align-self: stretch;\n  flex-shrink: 0;\n  position: relative;\n  min-width: 0;\n  height: 31px;\n  color: #3b3b3b;\n  font-family: ShellMedium, var(--default-font-family);\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 31px;\n  text-align: left;\n  white-space: nowrap;\n  z-index: 1;\n}\n\n.cta-description {\n  align-self: stretch;\n  flex-shrink: 0;\n  position: relative;\n  min-width: 0;\n  font-family: ShellBook, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 28.8px;\n  text-align: left;\n  z-index: 2;\n}\n\n.cta-text {\n  position: relative;\n  color: #3b3b3b;\n  font-family: ShellBook, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 28.8px;\n  text-align: left;\n}\n\n.cta-highlight {\n  position: relative;\n  color: #3b3b3b;\n  font-family: ShellHeavy, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28.8px;\n  text-align: left;\n}\n\n.cta-space {\n  position: relative;\n  color: #3b3b3b;\n  font-family: ShellHeavy, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28.8px;\n  text-align: left;\n}\n\n.cta-highlight-red {\n  position: relative;\n  color: var(--color-contrast-dark-red);\n  font-family: ShellHeavy, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28.8px;\n  text-align: left;\n}\n\n.cta-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;\n  flex-wrap: nowrap;\n  flex-shrink: 0;\n  position: relative;\n  min-width: 0;\n  height: 54.382px;\n  padding: 14px 20px 14px 20px;\n  background: var(--color-primary-red);\n  border: 1.5px solid var(--color-primary-red);\n  z-index: 3;\n  overflow: hidden;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.cta-button:hover {\n  background: #b51819;\n}\n\n.cta-button-text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  flex-shrink: 0;\n  position: relative;\n  width: 191px;\n  padding: 0 8px 0 8px;\n  z-index: 4;\n  color: #ffffff;\n  font-family: ShellMedium, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* Navigation Controls */\n.navigation-controls {\n  position: absolute;\n  bottom: 0;\n  left: 46%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: center;\n  gap: 5px; /* Espaçamento entre os botões */\n  z-index: 20;\n}\n\n/* Estilo para quando há apenas uma seta visível */\n.navigation-controls.single-arrow {\n  justify-content: center;\n  left: 44%;\n}\n\n.navigation-controls.first-slide .nav-button#prev-button,\n.navigation-controls.last-slide .nav-button#next-button {\n  display: none;\n}\n\n.nav-button {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.nav-button:hover {\n  transform: scale(1.05);\n}\n\n.nav-button img {\n  width: 48px;\n  height: 48px;\n}\n\n.nav-button {\n  width: 48px;\n  height: 48px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.arrow {\n  width: 20px;\n  height: 20px;\n  border-top: 3px solid white;\n  border-right: 3px solid white;\n  transition: transform 0.3s ease;\n}\n\n.arrow-right {\n  transform: rotate(45deg);\n}\n\n.arrow-left {\n  transform: rotate(-135deg);\n}\n\n/* Prize Images Container (hidden) */\n.prize-images {\n  display: none;\n}\n\n.awards--extra {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  width: 100%;\n}\n.awards--extra p {\n  color: var(--color-primary-white);\n  text-align: center;\n}\n.awards--extra--center,\n.awards--extra--left {\n  background: var(--color-primary-green-ethanol);\n  padding: 27px 40px;\n  position: relative;\n  width: 280px;\n}\n.awards--extra--center::before {\n  background: var(--color-primary-white);\n  content: '';\n  height: 70%;\n  left: -1px;\n  position: absolute;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0px);\n  width: 1px;\n}\n.awards--extra--left {\n  border-radius: 24px 0px 0px 24px;\n}\n.awards--extra--right {\n  border-radius: 0px 24px 24px 0px;\n  background: var(--color-primary-red);\n  padding: 12px 24px;\n  width: 336px;\n}\n\n/* Media Queries para Responsividade */\n@media (max-width: 1360px) {\n  .slider-left-container .prize-item.active {\n    left: 10%;\n  }\n}\n\n@media (max-width: 1280px) {\n  .prize-slider {\n    max-width: 798px;\n    height: 500px;\n    margin: 0 auto;\n    padding: 40px 0 80px;\n    justify-content: center;\n    gap: 50px;\n  }\n\n  .slider-left-container,\n  .slider-right-container {\n    max-width: 100%;\n    width: 100%;\n    height: 50%;\n    padding: 10px;\n    z-index: -1;\n  }\n\n  .slider-left-container {\n    max-width: 400px;\n  }\n\n  .slider-left-container .prize-item {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .slider-left-container .prize-item.active {\n    left: 0;\n  }\n\n  .slider-right-container {\n    opacity: 0;\n    display: none;\n  }\n\n  .prize-info.active {\n    left: unset;\n    right: 0;\n    transform: translateY(-50%);\n  }\n\n  .navigation-controls {\n    left: 50%;\n  }\n\n  .navigation-controls.single-arrow {\n    left: 50%;\n  }\n}\n\n@media (max-width: 768px) {\n  .prize-slider {\n    height: 522px;\n    margin: 0 auto;\n    padding: 0;\n  }\n\n  .slider-left-container,\n  .slider-right-container {\n    max-width: 100%;\n    width: 100%;\n    height: 50%;\n    padding: 10px;\n    z-index: -1;\n  }\n\n  .slider-left-container .prize-item {\n    max-width: 100%;\n  }\n\n  .slider-left-container .prize-item.active {\n    max-width: 100%;\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n    left: 0;\n  }\n\n  .slider-right-container {\n    opacity: 0;\n  }\n\n  .prize-item {\n    width: 300px;\n    height: 300px;\n  }\n\n  .prev-button,\n  .next-button {\n    width: 30px;\n    height: 30px;\n  }\n\n  .prev-button {\n    left: 10px;\n  }\n\n  .next-button {\n    right: 10px;\n  }\n\n  .prize-info {\n    padding: 15px;\n  }\n\n  .prize-info.active {\n    max-width: 100%;\n    width: 100%;\n    padding: 0 20px;\n    text-align: center;\n    top: 0;\n    left: 0;\n    transform: translate(0);\n    animation: fadeIn 00ms cubic-bezier(0.4, 0, 0.2, 1) forwards;\n  }\n  \n  .prize-title {\n    font-size: 24px;\n    margin-bottom: 11px;\n  }\n\n  .prize-type {\n    font-size: 14px;\n    margin: 0;\n  }\n\n  .prize-description {\n    font-size: 14px;\n    position: absolute;\n    bottom: -400px;\n    left: 0;\n  }\n\n  .prize-categories {\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px 0;\n  }\n\n  .highlight {\n    font-size: 20px;\n  }\n\n  .category-text {\n    font-size: 16px;\n  }\n\n  .navigation-controls {\n    width: 100%;\n    top: 50%;\n    bottom: unset;\n    left: 0;\n    transform: translate(0);\n  }\n\n  .navigation-controls.single-arrow {\n    left: 0;\n  }\n\n  .navigation-controls #prev-button,\n  .navigation-controls #next-button {\n    position: absolute;\n  }\n\n  .navigation-controls #prev-button {\n    left: 0;\n  }\n\n  .navigation-controls #next-button {\n    right: 0;\n  }\n\n  .awards--extra {\n    flex-wrap: wrap;\n  }\n  .awards--extra > div {\n    height: 96px;\n  }\n  .awards--extra p.p2-paragraph {\n    font-size: var(--font-size-p3-paragraph);\n  }\n  .awards--extra--center,\n  .awards--extra--left {\n    padding: 18px 40px;\n    width: 50%;\n  }\n  .awards--extra--left {\n    border-radius: 24px 0px 0px 0px;\n  }\n  .awards--extra--center {\n    border-radius: 0px 24px 0px 0px;\n  }\n  .awards--extra--right {\n    border-radius: 0px 0px 24px 24px;\n    padding: 28px 24px;\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
